// // third-party
// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// import axios from "../../utlils/axios";

// import { dispatch } from "../index";

// // Define the state type
// interface UserInfoState {
//   error?: string | null; // Error can be a string or null
//   userInfo?: Record<string, unknown> | any; // You can use a more specific type instead of `Record<string, any>` if you know the structure of `userInfo`
//   // getRsaCredentialEncryptionKeyRes :  Record<string, unknown> | any;
// }

// // Initial state
// const initialState: UserInfoState = {
//   // error: null,
//   userInfo: {},
//   // getRsaCredentialEncryptionKeyRes: {},
// };

// // Create the slice
// const slice = createSlice({
//   name: "user-info",
//   initialState,
//   reducers: {
//     // HAS ERROR
//     hasError(state, action: PayloadAction<string | null>) {
//       state.error = action.payload;
//     },
//     // Add USER_INFO
//     addUserInfo(state, action: PayloadAction<Record<string, unknown>>) {
//       state.userInfo = action.payload;
//     },
//     // getRsaCredentialEncryptionKeySuccess(state, action) {
//     //   state.getRsaCredentialEncryptionKeyRes = action.payload;
//     // },
//   },
// });

// // Reducer
// export default slice.reducer;
// export const { addUserInfo } = slice.actions;

// // export function getRsaCredentialEncryptionKey() {
// //   return async () => {
// //     try {
// //       const response = await axios.get(`/credential-encryption-key`);
// //       dispatch(
// //         slice.actions.getRsaCredentialEncryptionKeySuccess(
// //           response.data
// //         )
// //       );
// //       return response;
// //     } catch (error) {
// //       console.log('error of the ras123')
// //       return error;
// //     }
// //   };
// // }

// // // src/store/userInfoSlice.ts
// // import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// // interface UserInfoState {
// //   organizationId: number;
// //   organizationType: string;
// //   passwordExpired: string;
// //   systemDate: string;
// // }

// // const initialState: UserInfoState = {
// //   organizationId: 0,
// //   organizationType: '',
// //   passwordExpired: '',
// //   systemDate: '',
// // };

// // const userInfoSlice = createSlice({
// //   name: 'userInfo',
// //   initialState,
// //   reducers: {
// //     setUserInfo(state, action: PayloadAction<UserInfoState>) {
// //       state.organizationId = action.payload.organizationId;
// //       state.organizationType = action.payload.organizationType;
// //       state.passwordExpired = action.payload.passwordExpired;
// //       state.systemDate = action.payload.systemDate;
// //     },
// //     resetUserInfo(state) {
// //       state.organizationId = 0;
// //       state.organizationType = '';
// //       state.passwordExpired = '';
// //       state.systemDate = '';
// //     },
// //   },
// // });

// // export const { setUserInfo, resetUserInfo } = userInfoSlice.actions;
// // export default userInfoSlice.reducer;


// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// // ✅ Define User Info State
// interface UserInfoState {
//   userInfo: Record<string, any>;
// }

// const initialState: UserInfoState = {
//   userInfo: {},
// };

// // ✅ Create User Info Slice
// const userInfoSlice = createSlice({
//   name: "userInfo",
//   initialState,
//   reducers: {
//     addUserInfo(state, action: PayloadAction<Record<string, unknown>>) {
//       state.userInfo = action.payload;
//     },
//     clearUserInfo(state) {
//       state.userInfo = {};
//     }
//   },
// });

// export const { addUserInfo, clearUserInfo } = userInfoSlice.actions;

// export default userInfoSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the User Info State
interface UserInfoState {
  userInfo: {
    token: string | null;
    isLoggedIn: boolean;
    isAdmin?: boolean;
  };
}

// Initial state
const initialState: UserInfoState = {
  userInfo: {
    token: "",
    isLoggedIn: false,
    isAdmin: false
  },
};

// Create User Info Slice
const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    addUserInfo(state, action: PayloadAction<UserInfoState["userInfo"]>) {
      state.userInfo = action.payload;
    },
    clearUserInfo(state) {
      state.userInfo = initialState.userInfo;
    }
  },
});

export const { addUserInfo, clearUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;

